import {booleanAttribute, ChangeDetectionStrategy, Component, input} from '@angular/core'

/**
 * Content that can be specified through ng-content:
 *
 * content="background-image"         -> background cover image / showBackgroundImage must be true
 * content="logo"                     -> logo image, placed next to title and description / showLogo must be true and an img tag should be found
 * cft-breadcrumbs or cft-back-button -> navigation controls
 * bgo-hero-call-to-action-section    -> a call to action / showCallToAction must be true
 * bgo-hero-selling-point             -> selling point bar / showSellingPointBar must be true
 * bgo-hero-partnership               -> partnership section / showPartnership must be true
 * bgo-hero-form or content="overlay" -> overlay component that will be placed slightly over the banner / showOverlay must be true
 */
@Component({
  selector: 'bgo-hero-cover',
  templateUrl: './hero-cover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      @reference '../../../../styles/app-reference.css';

      :host {
        @apply relative;
      }

      .logo-container ::ng-deep img {
        @apply h-full w-full rounded-lg bg-president-500 shadow-1;
      }
    `,
  ],
})
export class HeroCoverComponent {
  title = input<string>()
  description = input<string>()
  emptyCover = input(false, {
    transform: booleanAttribute,
  })

  /* Configuration flags related to ng-content */
  showCallToAction = input(true, {
    transform: booleanAttribute,
  })
  showSearch = input(false, {
    transform: booleanAttribute,
  })
  showSellingPointBar = input(true, {
    transform: booleanAttribute,
  })
  showPartnership = input(false, {
    transform: booleanAttribute,
  })
  showOverlay = input(false, {
    transform: booleanAttribute,
  })
  showTags = input(false, {
    transform: booleanAttribute,
  })
  reducedCoverTransparency = input(false, {
    transform: booleanAttribute,
  })
}
